import React  from "react";
import { useParams } from 'react-router-dom';
import ClientForm from "./components/ClientForm";
import Card from "components/card";

const EditClient = () => {

	const { clientId } = useParams();

	return (
	    <div>
	    		<div className="mt-5 grid h-full grid-cols-1 gap-4">
					<ClientForm recordId={clientId} mode="edit"/>
				</div>
	    </div>
    );
};

export default EditClient;